import WithModal from '../../../components/WithModal'
import StudentsInDailyTrip from '../../../components/studentsInTrip/StudentsInDailyTrip'
import {Button} from 'react-bootstrap'
import {BusLocationData} from '../../ts/trip'

function TripDetails({tripData}: {tripData: BusLocationData}) {
  return (
    <>
      <table className="border w-100">
        <tbody>
          <tr>
            <td className="border bg-gray-100 p-2">Trip Name</td>
            <td className="border p-2">{tripData.trip_name}</td>
          </tr>
          <tr className="tr">
            <td className="border td bg-gray-100 p-2">Trip Type</td>
            <td className="border td p-2">{tripData.trip_type}</td>
          </tr>
          <tr className="tr">
            <td className="border td bg-gray-100 p-2">Bus Brand</td>
            <td className="border td p-2">{tripData.bus_name}</td>
          </tr>
          <tr className="tr">
            <td className="border td bg-gray-100 p-2">Bus Number</td>
            <td className="border td p-2">{tripData.bus_number}</td>
          </tr>
          <tr className="tr">
            <td className="border td bg-gray-100 p-2">Bus Reg. Number:</td>
            <td className="border td p-2"> {tripData.bus_registration_number}</td>
          </tr>
          <tr className="tr">
            <td className="border td bg-gray-100 p-2">Start Location</td>
            <td className="border td p-2">{tripData.start_location}</td>
          </tr>
          <tr className="tr">
            <td className="border td bg-gray-100 p-2">Trip Start Time</td>
            <td className="border td p-2">{tripData.trip_start_time}</td>
          </tr>
          <tr className="tr">
            <td className="border td bg-gray-100 p-2">Trip End Time</td>
            <td className="border td p-2">{tripData.trip_end_time}</td>
          </tr>
          <tr className="tr">
            <td className="border td bg-gray-100 p-2">Driver Name</td>
            <td className="border td p-2">{tripData.driver_name}</td>
          </tr>
          <tr className="tr">
            <td className="border td bg-gray-100 p-2">Driver Mobile</td>
            <td className="border td p-2">{tripData.driver_mobile}</td>
          </tr>
          <tr className="tr">
            <td className="border td bg-gray-100 p-2">Shift Name</td>
            <td className="border td p-2">{tripData.shift_name}</td>
          </tr>
          <tr className="tr">
            <td className="border td bg-gray-100 p-2">Shift Starting Time</td>
            <td className="border td p-2">{tripData.shift_starting_time}</td>
          </tr>
          <tr className="tr">
            <td className="border td bg-gray-100 p-2">Shift Ending Time</td>
            <td className="border td p-2">{tripData.shift_ending_time}</td>
          </tr>
          <tr className="tr">
            <td className="border td bg-gray-100 p-2">Trip Started Time</td>
            <td className="border td p-2">{tripData.trip_started_time}</td>
          </tr>
          <tr className="tr">
            <td className="border td bg-gray-100 p-2">Trip Ended Time</td>
            <td className="border td p-2">{tripData.trip_ended_time}</td>
          </tr>
        </tbody>
      </table>
      <div className="pt-2 text-center">
        <WithModal
          renderModalBody={() => (
            <StudentsInDailyTrip
              dailyTripId={tripData.geoJson.features[0].properties!.daily_trip_id}
            />
          )}
          modalTitle={
            <span>
              Students in the Trip <span className="text-primary">{tripData.trip_name}</span>
            </span>
          }
          modalAttrs={{size: 'xl'}}
        >
          <Button size="sm" className="gradient-btn rounded">
            See Students in Trip
          </Button>
        </WithModal>
      </div>
    </>
  )
}

export default TripDetails
